import { FC, FormEvent, useCallback, useEffect } from "react";

import { Form, FormikFormProps } from "formik";

import { OrderFields } from "../../constants";
import useOrderFormik from "../../hooks/useOrderFormik";

// This custom formik form clears fields errors after changing their value

const useClearFieldErrorOnChange = (fieldName: OrderFields): void => {
  const {
    values: { [fieldName]: fieldValue },
    setFieldError,
  } = useOrderFormik();

  useEffect(() => {
    setFieldError(fieldName, "");
  }, [fieldValue, fieldName, setFieldError]);
};

const OrderForm: FC<FormikFormProps> = ({ ...rest }) => {
  // This is list of custom fields, which do not trigger native change event in form
  useClearFieldErrorOnChange(OrderFields.STARTING_COUNTRY);
  useClearFieldErrorOnChange(OrderFields.DESTINATION_COUNTRY);
  useClearFieldErrorOnChange(OrderFields.PACKAGE_SIZE);
  useClearFieldErrorOnChange(OrderFields.PACKAGE_WEIGHT);
  useClearFieldErrorOnChange(OrderFields.DELIVERY_METHOD);
  useClearFieldErrorOnChange(OrderFields.RETURN_LOCKER);
  useClearFieldErrorOnChange(OrderFields.RECEIVER_LOCKER);
  useClearFieldErrorOnChange(OrderFields.NEW_ADDRESS_LOCKER);
  useClearFieldErrorOnChange(OrderFields.PICKUP_DATE);
  useClearFieldErrorOnChange(OrderFields.PICKUP_TIME_FROM);
  useClearFieldErrorOnChange(OrderFields.PICKUP_TIME_TILL);
  useClearFieldErrorOnChange(OrderFields.TERMS_AGREEMENT);
  useClearFieldErrorOnChange(OrderFields.PAYMENT_METHOD);
  useClearFieldErrorOnChange(OrderFields.RECEIVER_PHONE_NUMBER);
  useClearFieldErrorOnChange(OrderFields.CONTACT_PERSON_PHONE_NUMBER);
  useClearFieldErrorOnChange(OrderFields.SENDER_PHONE_NUMBER);
  useClearFieldErrorOnChange(OrderFields.NEW_ADDRESS_PHONE);

  const { setFieldError } = useOrderFormik();

  const handleFormChange = useCallback(
    (evt: FormEvent) => {
      const evtTarget = evt.target as HTMLInputElement;
      const fieldName = evtTarget.name;
      if (!fieldName) {
        return;
      }
      setFieldError(fieldName, "");
    },
    [setFieldError]
  );

  return <Form {...rest} onChange={handleFormChange} />;
};
export default OrderForm;
